import React, {useEffect, useState} from 'react';
import {GET_COLLECTION_DATA} from '../../api';
import 'datatables.net';
import 'datatables.net-responsive';
import $ from "jquery";
import cogoToast from "cogo-toast";
import {bus} from "../../request";
import {capitalize} from "../../utils/capitalize";
import {useSelector} from "react-redux";

const Vehicle = () => {

    document.title = "Vehicle";

    const auth = useSelector((state) => state.auth.user);

    const token = localStorage.getItem('jwtToken');
    const [busId, setBusId] = useState(0);
    const [formLoading, setFormLoading] = useState(false);
    const [editForm, setEditForm] = useState(false);

    useEffect(() => {
        let td_bus = $('#td-bus').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Please Wait</p>'
            },
            "searching": true,
            "lengthMenu": [[10], [10]],
            ordering: false,
            searchDelay: 650,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA(auth.user.level), {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "buses",
                        fieldname: "number_plate",
                        pageSize: data.start,
                        filter: {
                            academia: auth.user.sub
                        },
                        format: 'json',
                        populate: 'cover',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success : function(res) {
                        let array = [];
                        res.data.map((data) => {array.push({raw: data})});
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return data.make;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.model;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.color;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return data.number_plate
                    },
                    "targets": 3
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only">
                                    <a href="#" class="nav-link edit_bus"><i class="fa fa-pencil-alt"></i> Edit</a><a href="#" class="nav-link delete_bus"><i class="fa fa-trash-alt"></i> Delete</a>
                                </nav>`
                    },
                    "targets": 4
                }
            ]
        });

        td_bus.on('click', '.delete_bus', function(e) {
            e.preventDefault();
            let extract_td = td_bus.row($(this).closest('tr')).data();
            $(".data-message").text(`Are you sure, you want to delete, ${capitalize(extract_td.raw.number_plate)}?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                bus("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Bus successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        td_bus.on('click', '.edit_bus', function(e) {
            e.preventDefault();
            let extract_td = td_bus.row($(this).closest('tr')).data();
            setBusId(extract_td.raw._id);
            setEditForm(true);

            $("#make").val(extract_td.raw.make);
            $("#model").val(extract_td.raw.model);
            $("#color").val(extract_td.raw.color);
            $("#number_plate").val(extract_td.raw.number_plate);
            $("#year").val(extract_td.raw.year);

            $("#password").prop("required", false);

            $("#modalBus").modal({backdrop: 'static', keyboard: false}, "show");
        });
    }, []);

    const handleSubmit = async(e) => {
        e.preventDefault();
        setFormLoading(true);

        let make = $('#make').val();
        let model = $('#model').val();
        let color = $('#color').val();
        let number_plate = $('#number_plate').val();
        let year = $('#year').val();

        if(editForm) {
            let raw = {
                id: busId,
                make,
                model,
                color,
                number_plate,
                year
            }

            bus("put", raw).then((result) => {
                setFormLoading(false);

                if(!result.error) {
                    cogoToast.success("Data successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalBus", "bus_form");
                    reloadTable();
                }
            });

            return false;
        }

        let raw = {
            make,
            model,
            color,
            number_plate,
            year
        }

        bus("post", raw).then((result) => {
            setFormLoading(false);

            if(!result.error) {
                cogoToast.success("Data successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalBus", "bus_form");
                reloadTable();
            }
        });
    }

    const handleBusForm = (e) => {
        e.preventDefault();
        setEditForm(false);
        $("#password").prop("required", true);
        $('#bus_form').parsley();
        $("#modalBus").modal({backdrop: 'static', keyboard: false}, "show");
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const onCloseModal = (id, form) => {
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        $(`#${form}`).parsley().reset();
        $(".modal-backdrop").remove();
    };

    const reloadTable = () => {
        $('#td-bus').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Bus</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Bus</h4>
                    </div>
                    <div className="d-none d-md-block">
                        <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5 outline-none" onClick={handleBusForm.bind()}><i className="wd-10 mg-r-5 fa fa-plus"></i> Add New</button>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Total Bus</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0" onClick={handleBusForm.bind()}><i className="icon ion-md-add"></i></a>
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => $('#td-bus').DataTable().ajax.reload()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="td-bus" className="table table-hover" style={{width: "100%"}}>
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="wd-20p">Make</th>
                                        <th className="wd-20p">Model</th>
                                        <th className="wd-20p">Color</th>
                                        <th className="wd-20p">Number Plate</th>
                                        <th className="wd-20p">Action</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalBus" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </a>
                            <div className="media-body">
                                <a href="" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={onCloseModal.bind(null, "modalBus", "bus_form")} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </a>
                                <h4 className="tx-18 tx-sm-20 mg-b-2" id="edit_title">Bus</h4>
                                <p className="tx-13 tx-color-02 mg-b-0" id="edit_subtitle">Fill all the required field</p>
                            </div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="bus_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                <div id="makeWrapper" className="form-group parsley-input">
                                    <label>Make<span className="tx-danger">*</span></label>
                                    <input id="make" type="text" className="form-control"
                                           placeholder="Enter make"
                                           autoComplete="off"
                                           data-parsley-class-handler="#makeWrapper" required/>
                                </div>

                                <div id="modelWrapper" className="form-group parsley-input">
                                    <label>Model<span className="tx-danger">*</span></label>
                                    <input id="model" type="text" className="form-control"
                                           placeholder="Enter model"
                                           autoComplete="off"
                                           data-parsley-class-handler="#modelWrapper" required/>
                                </div>

                                <div id="colorWrapper" className="form-group parsley-input">
                                    <label>Color<span className="tx-danger">*</span></label>
                                    <input id="color" type="text" className="form-control"
                                           placeholder="Enter color"
                                           autoComplete="off"
                                           data-parsley-class-handler="#colorWrapper" required/>
                                </div>

                                <div id="yearWrapper" className="form-group parsley-input">
                                    <label>Year<span className="tx-danger">*</span></label>
                                    <input id="year" type="text" className="form-control"
                                           placeholder="Enter year"
                                           autoComplete="off"
                                           data-parsley-class-handler="#yearWrapper" required/>
                                </div>

                                <div id="numberWrapper" className="form-group parsley-input">
                                    <label>Number Plate<span className="tx-danger">*</span></label>
                                    <input id="number_plate" type="text" className="form-control"
                                           placeholder="Enter Number Plate"
                                           autoComplete="off"
                                           data-parsley-class-handler="#numberWrapper" required/>
                                </div>

                                {formLoading ? <button disabled className="btn btn-brand-02 btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status"
                                                                                                             aria-hidden="true"/>Please Wait</button> :
                                    <button className="btn btn-brand-02 btn-block mt-2"><i
                                        className="ion-md-add"/> Finish</button>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mg-b-0 data-message">Empty</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                            <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Vehicle;
